import { useQuery } from 'react-query';
import { getUxFeedbackFeatures } from '@yandex-int/k-common/client/api';
import type { actions as uxFeedbackActions } from '@edu-frontend/modules/src/shared/lib/uxFeedbackWidget';

import { getUniqueQueryKeys } from 'utils/getUniqueQueryKey';

type FeatureName =
    | typeof uxFeedbackActions.TEAM_WO_NO_ASSIGNED
    | typeof uxFeedbackActions.LONG_NOT_SOLVED
    | typeof uxFeedbackActions.ONLY_ONE_TEAM;

const keys = getUniqueQueryKeys(['uxFeedbackFeatures']);

export const useUxFeedbackFeatures = (enabled: boolean) => {
    return useQuery([keys.uxFeedbackFeatures], getUxFeedbackFeatures<FeatureName>, { enabled });
};
